import {Race} from '../../models/race';
import {Permission} from '../../enumerations/permission';
import {RaceState} from '../../enumerations/race_state';

export const isAuthorized = (permission: Permission, race: Race): boolean => {
    return [RaceState.ABORTED, RaceState.IDLE].includes(race.state);
};
